import { render, staticRenderFns } from "./ButtonPopup.vue?vue&type=template&id=8ba22b22"
import script from "./ButtonPopup.vue?vue&type=script&lang=js"
export * from "./ButtonPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports